(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-grid-lightbox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeLightbox(dialog) {
      if (dialog && dialog.open) dialog.close();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lightbox-trigger]');
      if (trigger) {
        var section = trigger.closest('.section');
        var dialog = section && section.querySelector('[data-image-lightbox]');
        if (!dialog) return;

        // Video wins over the image when the block has one.
        var templateId = trigger.getAttribute('data-lightbox-video');
        var template = templateId ? document.getElementById(templateId) : null;
        if (template) {
          dialog.appendChild(template.content.cloneNode(true));
          dialog.showModal();
          var video = dialog.querySelector('video');
          if (video) {
            video.setAttribute('playsinline', '');
            // video_tag adds muted alongside autoplay; with no controls the
            // customer couldn't unmute, so start with sound instead.
            video.removeAttribute('muted');
            video.muted = false;
            // The click is a user gesture, so sound-on playback is allowed.
            // There are no controls to fall back on, so if a browser still
            // blocks it, retry muted - the loop must always run.
            var playing = video.play();
            if (playing && playing.catch) {
              playing.catch(function () {
                video.muted = true;
                var retry = video.play();
                if (retry && retry.catch) retry.catch(function () {});
              });
            }
          }
          return;
        }

        var src = trigger.getAttribute('data-lightbox-src');
        if (!src) return;
        var img = dialog.querySelector('[data-lightbox-img]');
        img.src = src;
        img.alt = trigger.getAttribute('data-lightbox-alt') || '';
        img.hidden = false;
        dialog.showModal();
        return;
      }

      var closeButton = event.target.closest('[data-lightbox-close]');
      if (closeButton) {
        closeLightbox(closeButton.closest('[data-image-lightbox]'));
        return;
      }

      // Click on the dark area around the image (the dialog itself).
      if (event.target.matches && event.target.matches('[data-image-lightbox]')) {
        closeLightbox(event.target);
      }
    });

    // Escape closes natively; clear the image and tear down any video so
    // audio/downloads stop and the next open never flashes the previous
    // media. 'close' doesn't bubble, so capture it.
    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (!dialog.matches || !dialog.matches('[data-image-lightbox]')) return;
        var img = dialog.querySelector('[data-lightbox-img]');
        if (img) {
          img.removeAttribute('src');
          img.hidden = true;
        }
        var videos = dialog.querySelectorAll('video');
        for (var i = 0; i < videos.length; i++) {
          videos[i].pause();
          videos[i].remove();
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
